<number-format-tag>
    <script>
        export default {
            setInnerHTML(number) {
                this.root.innerHTML = new Intl.NumberFormat(
                    'en-IN', { 
                        maximumSignificantDigits: 3 
                    }
                ).format(number);
            },
            onMounted(props, state) {
                this.setInnerHTML(props.number)
            },
            onUpdated(props, state) {
                this.setInnerHTML(props.number)
            }
        }
    </script>
</number-format-tag>
